import React from 'react';
import styles from './RequiredStar.module.css';

interface RequiredStarProps {
  className?: string;
}

const RequiredStar: React.FC<RequiredStarProps> = ({ className }) => {
  return (
    <span className={`${styles.requiredStar} ${className || ''}`} title="Required field">
      *
    </span>
  );
};

export default RequiredStar; 